import { fetchJson } from "../Fetching";

const fetchGraphs = ({
  company_id,
  start_date,
  end_date,
  start_date_f,
  end_date_f,
  product_ids = [],
  company_branch_ids = [],
  test_name_ids = [],
  data_field_query_params = [],
  data_field_names_breakdown = [],
  client_suite_id
}) => {
  const params = {
    form: {
      company_id,
      company_branch_ids: company_branch_ids,
      start_date: start_date_f || (start_date ? start_date.format("YYYY-MM-DD") : null),
      end_date: end_date_f || (end_date ? end_date.format("YYYY-MM-DD") : null),
      product_ids,
      test_name_ids,
      data_field_names_breakdown: data_field_names_breakdown.map(o => o.value),
      data_field_query_params: data_field_query_params ? data_field_query_params : [],
      client_suite_id
    }
  };
  return fetchJson("/sample_reporting/trending/graphs.json", params);
};

export { fetchGraphs };
